import { JetView } from 'webix-jet'; // Importing JetView from the webix-jet library for creating views
import { allpayments } from 'models/allpayments'; // Importing allpayments model for data handling
import { devConfig } from 'config/config'; // Importing development configuration settings

/**
 * Class representing a view for withdrawal requests.
 * @extends JetView
 */
export default class tableWithdrawalRequestView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service for translations
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        var vthis = this; // Reference to the current context
        const cur_user = this.getParam('user', true); // Getting the current user ID from parameters
        const url = devConfig.geturlApi() + 'es/Client/GetClientWithdrawalRequests?PlayerId=' + cur_user + '&'; // API URL for fetching withdrawal requests

        return {
            rows: [
                {
                    id: 'preloader', // ID for the preloader element
                    cols: [
                        {
                            view: 'datatable', // Webix datatable component
                            id: 'table', // ID for the datatable
                            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
                            select: true, // Enable row selection
                            height: screen.width < 500 ? 405 : 0, // Conditional height based on screen width
                            columns: [
                                {
                                    id: 'detailTittle', // Column ID for details
                                    header: '', // Column header
                                    width: 50, // Column width
                                    height: 25, // Column height
                                    tooltip: _('Detalles'), // Tooltip for the column
                                    template: function (obj) { // Template for rendering details icon
                                        return "<span class='webix_icon wxi-close details'></span>";
                                    },
                                },
                                {
                                    id: 'ActionTittle', // Column ID for actions
                                    header: '', // Column header
                                    width: 70, // Column width
                                    height: 25, // Column height
                                    tooltip: 'Acción', // Tooltip for the column
                                    template: function (obj) { // Template for rendering action icons based on state
                                        if (
                                            obj.State == 'A' &&
                                            obj.AccountBank !== '' &&
                                            obj.AccountBank !== undefined &&
                                            obj.AccountBank !== null
                                        ) {
                                            if (
                                                devConfig.getPermAction(
                                                    'agentComissionsWithdrawalRequestsApprove',
                                                    'Approve',
                                                )
                                            ) {
                                                return "<span placeholder='Aprobar' class='webix_icon wxi-close approve prm-agentComissionsWithdrawalRequestsApprove'></span><span class='webix_icon wxi-close torefuse prm-agentComissionsWithdrawalRequestsApprove'></span>";
                                            } else {
                                                return '';
                                            }
                                        } else {
                                            if (
                                                obj.State == 'P' &&
                                                obj.AccountBank !== '' &&
                                                obj.AccountBank !== undefined &&
                                                obj.AccountBank !== null
                                            ) {
                                                if (
                                                    devConfig.getPermAction(
                                                        'agentComissionsWithdrawalRequestsPay',
                                                        'Pay',
                                                    )
                                                ) {
                                                    return "<span placeholder='Pagar' class='webix_icon wxi-close pay prm-agentComissionsWithdrawalRequestsPay'></span><span class='webix_icon wxi-close torefuse prm-agentComissionsWithdrawalRequestsPay'></span>";
                                                } else {
                                                    return '';
                                                }
                                            } else {
                                                return '';
                                            }
                                        }
                                    },
                                },
                                {
                                    id: 'Id', // Column ID for withdrawal request ID
                                    header: 'Id', // Column header
                                    width: 80, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'ClientId', // Column ID for client ID
                                    header: _('ID Cliente'), // Column header with localization
                                    width: 90, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'ClientName', // Column ID for client name
                                    header: _('Nombre Cliente'), // Column header with localization
                                    width: 250, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'VerifdniAnt', // Column ID for DNI verification
                                    header: _('DNI'), // Column header with localization
                                    width: 50, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Amount', // Column ID for withdrawal amount
                                    header: _('Valor'), // Column header with localization
                                    format: webix.i18n.priceFormat, // Formatting for price
                                    exportType: 'number', // Export type for the column
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'State', // Column ID for request state
                                    header: _('Estado'), // Column header with localization
                                    options: [ // Options for state selection
                                        { id: '', value: _('None') },
                                        { id: 'A', value: _('Activado') },
                                        { id: 'C', value: _('Cancelado') },
                                        { id: 'I', value: _('Pagada') },
                                        { id: 'E', value: _('Eliminado') },
                                        { id: 'P', value: _('Pendiente') },
                                        { id: 'R', value: _('Rechazado') },
                                    ],
                                },
                                {
                                    id: 'CreatedLocal', // Column ID for creation date
                                    header: _('Fecha'), // Column header with localization
                                    width: 150, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Department', // Column ID for department
                                    header: _('Departamento'), // Column header with localization
                                    width: 150, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'City', // Column ID for city
                                    header: _('Ciudad'), // Column header with localization
                                    width: 150, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'WayPay', // Column ID for payment method
                                    header: _('Forma de pago'), // Column header with localization
                                    width: 150, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'AccountBank', // Column ID for bank account
                                    header: _('Cuenta Bancaria'), // Column header with localization
                                    width: 150, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'CodeInterbank', // Column ID for interbank code
                                    header: _('Código Interbancario'), // Column header with localization
                                    width: 150, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Ip', // Column ID for IP address
                                    header: 'IP', // Column header
                                    width: 250, // Column width
                                    sort: 'int', // Sorting type
                                },
                            ],
                            onClick: { // Event handlers for click actions
                                details: function (euv, id) { // Handler for details click
                                    var item = this.getItem(id); // Get the clicked item
                                    this.$scope.app.callEvent('user:id', [item.Id]); // Trigger user ID event
                                },
                                pay: function (euv, id) { // Handler for pay action click
                                    var vvthis = this; // Reference to the current context
                                    webix
                                        .modalbox({ // Display modal box for payment options
                                            title: 'Pregunta ',
                                            buttons: [_('Pagar por Sistema'), _('Pagado fisicamente'), _('Cancelar')],
                                            text: _('Elija la forma de pago'),
                                            width: 500,
                                        })
                                        .then(function (result) { // Handle modal result
                                            switch (result) {
                                                case '0': // Payment by system
                                                    webix.confirm({ // Confirmation for payment
                                                        type: 'confirm-warning',
                                                        text:
                                                            _('Advertencia!') +
                                                            '<br/>' +
                                                            _('Desea Pagar Nota de Retiro?'),
                                                        ok: _('Pagar Nota'),
                                                        cancel: _('Salir'),
                                                        callback: function (action) { // Callback for confirmation action
                                                            if (action === true) {
                                                                var item = vvthis.getItem(id); // Get the clicked item
                                                                webix
                                                                    .ajax() // AJAX request to pay withdrawal
                                                                    .headers({
                                                                        'Content-type': 'application/json',
                                                                    })
                                                                    .post(
                                                                        devConfig.geturlApi() +
                                                                        'Client/PayWithdrawalRequestsAPI',
                                                                        '{ "Id":' + item.Id + '}',
                                                                        {
                                                                            error: function (
                                                                                text,
                                                                                data,
                                                                                XmlHttpRequest,
                                                                            ) {
                                                                                webix.message(_('Error! ')); // Error message
                                                                            },
                                                                            success: function (
                                                                                text,
                                                                                data,
                                                                                XmlHttpRequest,
                                                                            ) {
                                                                                item.State = 'I'; // Update item state to 'Paid'
                                                                                webix.message(
                                                                                    _('Envio de solicitud de pago. '), // Success message
                                                                                );
                                                                                vthis.$$('table').clearAll(); // Clear the table
                                                                                vthis.$$('table').load(url); // Reload the table data
                                                                            },
                                                                        },
                                                                    );
                                                            }
                                                        },
                                                    });
                                                    break;
                                                case '1': // Payment physically
                                                    webix.confirm({ // Confirmation for physical payment
                                                        type: 'confirm-warning',
                                                        text:
                                                            _('Advertencia!') +
                                                            '<br/>' +
                                                            _('Desea Pagar Nota de Retiro?'),
                                                        ok: _('Pagar Nota'),
                                                        cancel: _('Salir'),
                                                        callback: function (action) { // Callback for confirmation action
                                                            if (action === true) {
                                                                var item = vvthis.getItem(id); // Get the clicked item
                                                                webix
                                                                    .ajax() // AJAX request to pay withdrawal
                                                                    .headers({
                                                                        'Content-type': 'application/json',
                                                                    })
                                                                    .post(
                                                                        devConfig.geturlApi() +
                                                                        'Client/PayWithdrawalRequests',
                                                                        '{ "Id":' + item.Id + '}',
                                                                        {
                                                                            error: function (
                                                                                text,
                                                                                data,
                                                                                XmlHttpRequest,
                                                                            ) {
                                                                                webix.message(_('Error! ')); // Error message
                                                                            },
                                                                            success: function (
                                                                                text,
                                                                                data,
                                                                                XmlHttpRequest,
                                                                            ) {
                                                                                item.State = 'I'; // Update item state to 'Paid'
                                                                                webix.message(
                                                                                    _('Nota de Retiro Pagada'), // Success message
                                                                                );
                                                                                vthis.$$('table').clearAll(); // Clear the table
                                                                                vthis.$$('table').load(url); // Reload the table data
                                                                            },
                                                                        },
                                                                    );
                                                            }
                                                        },
                                                    });
                                                    break;
                                                case '2': // Cancel action
                                                    break;
                                            }
                                        });
                                },
                                approve: function (euv, id) { // Handler for approve action click
                                    var vvthis = this; // Reference to the current context
                                    webix.confirm({ // Confirmation for approval
                                        type: 'confirm-warning',
                                        text: _('Advertencia!') + '<br/>' + _('Desea Aprobar Nota de Retiro?'),
                                        ok: _('Aprobar Nota'),
                                        cancel: _('Salir'),
                                        callback: function (action) { // Callback for confirmation action
                                            if (action === true) {
                                                var item = vvthis.getItem(id); // Get the clicked item
                                                webix
                                                    .ajax() // AJAX request to approve withdrawal
                                                    .headers({
                                                        'Content-type': 'application/json',
                                                    })
                                                    .post(
                                                        devConfig.geturlApi() + 'Client/AllowWithdrawalRequests',
                                                        '{ "Id":' + item.Id + '}',
                                                        {
                                                            error: function (text, data, XmlHttpRequest) {
                                                                webix.message(_('Error! ')); // Error message
                                                            },
                                                            success: function (text, data, XmlHttpRequest) {
                                                                item.State = 'P'; // Update item state to 'Pending'
                                                                webix.message(_('Nota de Retiro Aprobado')); // Success message
                                                                vthis.$$('table').clearAll(); // Clear the table
                                                                vthis.$$('table').load(url); // Reload the table data
                                                            },
                                                        },
                                                    );
                                            }
                                        },
                                    });
                                },
                                torefuse: function (euv, id) { // Handler for refuse action click
                                    var vvthis = this; // Reference to the current context
                                    webix.confirm({ // Confirmation for refusal
                                        type: 'confirm-warning',
                                        text: _('Advertencia!') + '<br/>' + _('Desea Rechazar Nota de Retiro?'),
                                        ok: _('Rechazar Nota'),
                                        cancel: _('Salir'),
                                        callback: function (action) { // Callback for confirmation action
                                            if (action === true) {
                                                var item = vvthis.getItem(id); // Get the clicked item
                                                webix
                                                    .ajax() // AJAX request to refuse withdrawal
                                                    .headers({
                                                        'Content-type': 'application/json',
                                                    })
                                                    .post(
                                                        devConfig.geturlApi() + 'Client/CancelClientRequests',
                                                        '{ "Id":' + item.Id + '}',
                                                        {
                                                            error: function (text, data, XmlHttpRequest) {
                                                                webix.message(_('Error! ')); // Error message
                                                            },
                                                            success: function (text, data, XmlHttpRequest) {
                                                                item.State = 'E'; // Update item state to 'Rejected'
                                                                webix.message(_('Nota de Retiro Rechazada')); // Success message
                                                                vthis.$$('table').clearAll(); // Clear the table
                                                                vthis.$$('table').load(url); // Reload the table data
                                                            },
                                                        },
                                                    );
                                            }
                                        },
                                    });
                                },
                            },
                            editable: true, // Enable editing in the datatable
                            tooltip: true, // Enable tooltips
                            math: true, // Enable mathematical operations
                            loadahead: devConfig.getDefaultDataFetch(), // Load ahead configuration
                            pager: 'pagerA', // ID for the pager component
                            url: url, // Data source URL for the datatable
                        },
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the view and sets up event handlers or data bindings.
     * @param {Object} grid - The grid component to be initialized.
     */
    init(grid) {
        // Retrieve the localization service and the current user parameter
        const _ = this.app.getService('locale')._;
        const cur_user = this.getParam('user', true);
        // Initialize the grid variable with the table component
        grid = $$('table');
        // Store the URL for data loading
        var url = grid.data.url;
        // Initialize filter variable
        var filter = '';
        // Listen for the 'bonusReport:filter' event to apply filters
        this.on(this.app, 'bonusReport:filter', (filterData) => {
            // Convert filterData object into an array of entries
            var object = Object.entries(filterData);
            var string1 = '';
            // Iterate through each filter entry
            for (var i = 0; i < object.length; i++) {
                // Check if the value is not an object and not empty
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    // Handle date range filtering
                    if (object[i][0] == 'Datepicker') {
                        var date = object[i][1].split(' - ');
                        console.log(date);
                        // Append dateFrom and dateTo to the filter string
                        string1 = string1 + '&dateFrom=' + date[0];
                        string1 = string1 + '&dateTo=' + date[1];
                    } else {
                        // Append other filter parameters to the string
                        string1 = string1 + '&' + object[i][0] + '=' + object[i][1];
                    }
                } else {
                    // Handle object type filter values
                    if (typeof object[i][1] === 'object') {
                        var object2 = Object.entries(object[i][1]);
                        // Iterate through the nested object entries
                        for (var j = 0; j < object2.length; j++) {
                            // Check if the value is not null
                            if (object2[j][1] !== null) {
                                // Handle start date filtering
                                if (object2[j][0] === 'start') {
                                    var d = new Date(object2[j][1]);
                                    var dateFrom =
                                        'MinCreatedLocal=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2);
                                    // Append the formatted start date to the filter string
                                    string1 = string1 + '&' + dateFrom;
                                } else {
                                    // Handle end date filtering
                                    if (object2[j][0] === 'end') {
                                        var d = new Date(object2[j][1]);
                                        var dateTo =
                                            'MaxCreatedLocal=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2);
                                        // Append the formatted end date to the filter string
                                        string1 = string1 + '&' + dateTo;
                                    }
                                }
                            }
                        }
                    }
                }
            }
            // Append the current user ID to the filter string
            string1 = string1 + '&PlayerId=' + cur_user;
            // Clear the grid data
            grid.clearAll();
            // Load the grid data with the constructed URL and filter parameters
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1);
            // Update the filter variable with the current filter string
            filter = string1;
        });
        // Attach an event to handle sorting in the grid
        grid.attachEvent('onAfterSort', function (by, dir, as) {
            // Reload the grid data with sorting parameters
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + filter + '&sort[' + by + ']=' + dir);
        });
        // Attach an event to handle actions before editing starts
        grid.attachEvent('onBeforeEditStart', function (id) {
            var item = this.getItem(id);
            console.log(item);
            // Check if the edited column is 'Action'
            if (id.column == 'Action') {
                // Validate the state of the item before allowing edit
                if (item.State == 'A') {
                } else if (item.State == 'P') {
                } else {
                    return false; // Prevent editing if state is not valid
                }
                console.log(id);
            }
        });
        // Attach an event to handle actions after editing stops
        grid.attachEvent('onAfterEditStop', function (state, editor, ignoreUpdate) {
            console.log(state);
            var item = this.getItem(editor.row);
            console.log(item);
            // Check if the edited value has changed
            if (state.value != state.old) {
                // Handle the case when the value is set to 'A'
                if (state.value == 'A') {
                    webix
                        .ajax()
                        .headers({
                            'Content-type': 'application/json',
                        })
                        .post(devConfig.geturlApi() + 'Client/AllowWithdrawalRequests', '{ "Id":' + item.Id + '}', {
                            error: function (text, data, XmlHttpRequest) {
                                webix.message(_('Error! '));
                            },
                            success: function (text, data, XmlHttpRequest) {
                                item.State = 'P'; // Update item state to 'P'
                                webix.message(_('Cell value was changed'));
                            },
                        });
                }
                // Handle the case when the value is set to 'P'
                if (state.value == 'P') {
                    webix
                        .ajax()
                        .headers({
                            'Content-type': 'application/json',
                        })
                        .post(devConfig.geturlApi() + 'Client/PayWithdrawalRequests', '{ "Id":' + item.Id + '}', {
                            error: function (text, data, XmlHttpRequest) {
                                webix.message(_('Error! '));
                            },
                            success: function (text, data, XmlHttpRequest) {
                                item.State = 'I'; // Update item state to 'I'
                                webix.message(_('Cell value was changed'));
                            },
                        });
                }
                // Handle the case when the value is set to 'E'
                if (state.value == 'E') {
                    webix
                        .ajax()
                        .headers({
                            'Content-type': 'application/json',
                        })
                        .post(devConfig.geturlApi() + 'Client/CancelClientRequests', '{ "Id":' + item.Id + '}', {
                            error: function (text, data, XmlHttpRequest) {
                                webix.message(_('Error! '));
                            },
                            success: function (text, data, XmlHttpRequest) {
                                item.State = 'E'; // Update item state to 'E'
                                webix.message(_('Cell value was changed'));
                            },
                        });
                }
            }
        });
        // Listen for the 'player:select' event to load data for the selected player
        this.on(this.app, 'player:select', (id) => {
            grid.load(grid.data.url + '?start=0&count=' + grid.data.$pagesize + '&PlayerId=' + id);
        }); // Placeholder for the initialization content
    }
}

// FILE DOCUMENTED
